import {Component, HostListener, OnInit, Output, EventEmitter, ElementRef, ViewChild} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {ApiClientService} from '../../services/api-client.service';

declare const moment: any;

@Component({
    selector: 'incident-reports-filter',
    templateUrl: './incident-reports-filter.component.html',
    styleUrls: ['./incident-reports-filter.component.scss']
})
export class IncidentReportsFilterComponent implements OnInit {
    showDropdown = false;
    incidentTypes: Array<any> = [];
    startDate = '';
    endDate = '';
    @Output('emitReports') emitReports: EventEmitter<any> = new EventEmitter();
    @ViewChild('startDateCheckbox') startDateCheckbox: ElementRef;
    @ViewChild('endDateCheckbox') endDateCheckbox: ElementRef;

    constructor(
        public api: ApiClientService,
        private urlService: UrlService
    ) {}

    ngOnInit() {
        this.getIncidentTypes();

        const createdAt = this.urlService.queryParams['createdAt'];
        if(createdAt) {
            if (createdAt.indexOf('<') != -1)
                this.startDate = moment(createdAt.split('<')[0])._d;
            if (createdAt.indexOf('>') != -1)
                this.endDate = moment(createdAt.split('>')[0]).add(-1, 'day')._d;
        }
    }

    changeFilter(filterName: string) {
        const filter = filterName;
        if (filter) {
            if (this.urlService.queryParams['report_type'] && (typeof this.urlService.queryParams['report_type'] == 'object')) {
                if (this.urlService.queryParams['report_type'].indexOf(filter) != -1)
                    this.urlService.queryParams['report_type'].splice(this.urlService.queryParams['report_type'].indexOf(filter), 1);
                else
                    this.urlService.queryParams['report_type'].push(filter);
            } else {
                if (this.urlService.queryParams['report_type']) {
                    if (filter != this.urlService.queryParams['report_type']) {
                        const temp = this.urlService.queryParams['report_type'];
                        this.urlService.queryParams['report_type'] = [];
                        this.urlService.queryParams['report_type'].push(temp);
                        this.urlService.queryParams['report_type'].push(filter);
                    } else
                        delete this.urlService.queryParams['report_type'];
                } else {
                    this.urlService.queryParams['report_type'] = [];
                    this.urlService.queryParams['report_type'].push(filter);
                }
            }
        }

        if (!this.startDate && !this.endDate)
            this.urlService.queryParams['createdAt'] = null;
        else {
            let createdAt = '';
            if (this.endDate)
                createdAt += (this.startDate ? '' : '<') +  moment(this.endDate).add(1, 'day').format('YYYY-MM-DD') + (this.startDate ? '<' : '');
            if (this.startDate)
                createdAt += '>' + moment(this.startDate).format('YYYY-MM-DD');
            this.urlService.queryParams['createdAt'] = createdAt ? createdAt : '';
        }
        this.urlService.setQueryParams(null, 1);
    }

    onStartDateChange() {
        if(this.startDate > this.endDate) {
            this.endDate = '';
        }
    }

    clearDates() {
        this.startDate = '';
        this.endDate = '';
        this.changeFilter(null);
    }

    filterCheckBoxChecked(checkboxValue): boolean {
        if (this.urlService.queryParams['report_type'] && typeof this.urlService.queryParams['report_type'] == 'object') {
            if (this.urlService.queryParams['report_type'].indexOf(checkboxValue) != -1)
                return true;
        } else if (this.urlService.queryParams['report_type']) {
            if (this.urlService.queryParams['report_type'] == (checkboxValue))
                return true;
        }
        return false;
    }

    getIncidentTypes(): void {
        if (this.incidentTypes.length) return;
        const url = `/v1/incident-reports-types.json?per-page=1000`;
        this.api.get('domainIncidentReports', url).subscribe(
            (res) => {
                this.incidentTypes = JSON.parse(res._body).entities;
                this.emitReports.emit(this.incidentTypes);
            },
            (error) => this.api.errorHandler(error, 'Failed get incident types')
        );
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('incident-reports-filter') &&
            !targetElement.closest('.cdk-overlay-container') &&
            !targetElement.closest('.mat-calendar-body-cell-content'))
            this.showDropdown = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/incident-reports-filter/incident-reports-filter.component.ts